<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>{{text}}</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Fechar</button>
</div>